import React, { useState } from "react";
import moment from "moment";
import cookie from "react-cookies";
import { connect } from "react-redux";

import { getLoggedProfile } from "../../actions/sessionAct";

import ChangeInfo from "./changeinfo";
import ChangeAvatar from "./changeavatar";
import ChangePhone from "./changephone";
import ChangeEmail from "./changeemail";
import VerifyPhoneOpt from "./verifyphoneopt";
import VerifyPhoneOptBreak from "./verifyphoneoptbreak";

import { IcCheckS, IcInfoOrangeS, IcMipoint, IcPencil, IcTotalTripM } from "../common/svg";

import avatar_default from "../../static/images/avatar_default.png";
import UnLinkFacebook from "./components/unlinkfacebook";
import LinkFacebook from "./components/linkfacebook";
import LinkGoogle from "./components/linkgoogle";
import UnLinkGoogle from "./components/unlinkgoogle";
import { genderMap, renderTimeCreated } from "../common/common";
import { OwnerResponse, OwnerStarBox } from "../profile/components/infoowner";
import VerifyEmail from "./verifyemail";

const InfoAccount = (props) => {
	const { session, totalTrip, mipoint, profile, fullProfile } = props;

	const [changeInfo, setChangeInfo] = useState(false);
	const [changeAvatar, setChangeAvatar] = useState(false);
	const [changePhone, setChangePhone] = useState(false);
	const [changeMail, setChangeMail] = useState(false);
	const [verifyPhoneOpt, setVerifyPhoneOpt] = useState(false);
	const [verifyPhoneOptBreak, setVerifyPhoneOptBreak] = useState(false);
	const [verifyEmail, setVerifyEmail] = useState(false);

	const getProfile = () => {
		props.dispatch(getLoggedProfile());
	};

	const showChangeInfo = () => {
		setChangeInfo(true);
		const utmSrc = cookie.load("_utm_src") || "web_directly";
		const utmExt = cookie.load("_utm_ext") || "no_label";
		// window.ga("send", "event", utmSrc, "CHANGE_INFO", utmExt);
		window.fbq("track", "CHANGE_INFO");
		window.gtag("event", "CHANGE_INFO", {
			event_category: utmSrc,
			event_label: utmExt,
			campaign: { source: utmSrc },
		});
	};

	const hideChangeInfo = () => {
		setChangeInfo(false);
	};

	const showChangeAvatar = () => {
		setChangeAvatar(true);
	};

	const hideChangeAvatar = () => {
		setChangeAvatar(false);
	};

	const showChangePhone = () => {
		setChangePhone(true);
		const utmSrc = cookie.load("_utm_src") || "web_directly";
		const utmExt = cookie.load("_utm_ext") || "no_label";
		// window.ga("send", "event", utmSrc, "VERIFY_PHONE", utmExt);
		window.fbq("track", "VERIFY_PHONE");
		window.gtag("event", "VERIFY_PHONE", {
			event_category: utmSrc,
			event_label: utmExt,
			campaign: { source: utmSrc },
		});
	};

	const hideChangePhone = () => {
		setChangePhone(false);
	};

	const showChangeEmail = () => {
		setChangeMail(true);
		const utmSrc = cookie.load("_utm_src") || "web_directly";
		const utmExt = cookie.load("_utm_ext") || "no_label";
		// window.ga("send", "event", utmSrc, "VERIFY_EMAIL", utmExt);
		window.fbq("track", "VERIFY_EMAIL");
		window.gtag("event", "VERIFY_EMAIL", {
			event_category: utmSrc,
			event_label: utmExt,
			campaign: { source: utmSrc },
		});
	};

	const hideChangeEmail = () => {
		setChangeMail(false);
	};

	const showVerifyPhoneOpt = () => {
		setVerifyPhoneOpt(true);
		const utmSrc = cookie.load("_utm_src") || "web_directly";
		const utmExt = cookie.load("_utm_ext") || "no_label";
		// window.ga("send", "event", utmSrc, "VERIFY_PHONE_OTP", utmExt);
		window.fbq("track", "VERIFY_PHONE_OTP");
		window.gtag("event", "VERIFY_PHONE_OTP", {
			event_category: utmSrc,
			event_label: utmExt,
			campaign: { source: utmSrc },
		});
	};

	const hideVerifyPhoneOpt = () => {
		setVerifyPhoneOpt(false);
	};

	const showVerifyPhoneOptBreak = () => {
		setVerifyPhoneOptBreak(true);
	};

	const hideVerifyPhoneOptBreak = () => {
		setVerifyPhoneOptBreak(false);
	};

	const showVerifyEmail = () => {
		setVerifyEmail(true);
	};

	const hideVerifyEmail = () => {
		setVerifyEmail(false);
	};

	return (
		<div className="content-item user-profile">
			<div className="title">
				<div className="title-edit">
					<h5>Thông tin tài khoản</h5>
					<div className="wrap-svg" onClick={showChangeInfo}>
						<IcPencil />
					</div>
				</div>
				<div className="total-trips">
					<div className="wrap-svg">
						<IcTotalTripM />
					</div>
					<p className="count">{totalTrip}</p>
					<span>chuyến</span>
				</div>
			</div>

			<div className="content">
				<div className="avatar-box">
					<div className={`avatar avatar--xl has-edit`} onClick={showChangeAvatar}>
						<img
							loading="lazy"
							src={profile.avatar && profile.avatar.fullUrl ? profile.avatar.fullUrl : avatar_default}
							alt={profile.name}
						/>
					</div>
					<h6>{profile.name}</h6>
					<p className="note">{renderTimeCreated(profile.timeCreated)}</p>
					<div className="trip-class">
						<div className="total-trips">
							<div className="wrap-svg">
								<IcTotalTripM />
							</div>
							<p className="count">{totalTrip}</p>
							<span>chuyến</span>
						</div>
						<div className="user-class">
							<div className="wrap-svg">
								<IcMipoint />
							</div>
							<div className="desc">
								<p>{mipoint} điểm </p>
							</div>
						</div>
					</div>
				</div>

				<div className="info-user">
					<div className="info-box">
						<div className="info-box__item">
							<p>Ngày sinh </p>
							<p className="main">
								{profile.dob !== 0 ? moment(profile.dob).format("DD/MM/YYYY") : "----/----/--------"}
							</p>
						</div>
						<div className="info-box__item">
							<p>Giới tính</p>
							<p className="main">{profile.gender ? genderMap[profile.gender] : "Nam"}</p>
						</div>
					</div>
					<div className="info-desc">
						<div className="info-desc__item">
							<div className="title-item">
								Số điện thoại
								{profile.phoneNumber && profile.phoneVerified !== 1 ? (
									<div className="note warning pointer" onClick={showVerifyPhoneOpt}>
										<div className="wrap-svg">
											<IcInfoOrangeS />
										</div>
										Xác minh
									</div>
								) : (
									<div className="note success">
										<div className="wrap-svg">
											<IcCheckS />
										</div>
										Đã xác thực
									</div>
								)}
							</div>
							{profile.phoneVerified === 1 ? (
								<div className="name" onClick={showChangePhone}>
									{profile.phoneNumber}
									<div className="wrap-svg">
										<IcPencil />
									</div>
								</div>
							) : (
								<div className="name" onClick={showChangePhone}>
									{profile.phoneNumber ? profile.phoneNumber : "Thêm số điện thoại"}
									<div className="wrap-svg">
										<IcPencil />
									</div>
								</div>
							)}
						</div>

						<div className="info-desc__item">
							<div className="title-item">
								Email
								{profile.emailVerified === 1 ? (
									<div className="note success">
										<div className="wrap-svg">
											<IcCheckS />
										</div>
										Đã xác thực
									</div>
								) : (
									<div className="note warning">
										<div className="wrap-svg">
											<IcInfoOrangeS />
										</div>
										Xác minh
									</div>
								)}
							</div>
							<div className="name" onClick={showChangeEmail}>
								{profile.email ? profile.email : "Thêm email"}
								<div className="wrap-svg">
									<IcPencil />
								</div>
							</div>
						</div>
						<div className="info-desc__item">
							<div className="title-item">Facebook</div>
							{fullProfile.facebookName ? (
								<div className="name">
									{fullProfile.facebookName}
									{fullProfile.facebookFr > 0 && <span>(có {fullProfile.facebookFr} bạn)</span>}
									<UnLinkFacebook getProfile={getProfile} />
								</div>
							) : (
								<LinkFacebook />
							)}
						</div>
						<div className="info-desc__item">
							<div className="title-item">Google</div>
							{fullProfile.googleName ? (
								<div className="name">
									{fullProfile.googleName}
									<UnLinkGoogle getProfile={getProfile} />
								</div>
							) : (
								<LinkGoogle />
							)}
						</div>
					</div>
				</div>
			</div>
			<div className="info-note">
				{profile.owner && profile.owner.responseRate !== "-" && (
					<>
						<OwnerResponse owner={profile.owner} />
						{(profile.owner.ownerHostFiveStarSD > 0 || profile.owner.ownerHostFiveStarWD > 0) && <OwnerStarBox />}
					</>
				)}
			</div>

			<ChangeInfo show={changeInfo} getProfile={getProfile} profile={session.profile} hideModal={hideChangeInfo} />
			<ChangeAvatar show={changeAvatar} getProfile={getProfile} hideModal={hideChangeAvatar} />
			<ChangePhone
				show={changePhone}
				hideModal={hideChangePhone}
				getProfile={getProfile}
				showVerifyPhoneOpt={showVerifyPhoneOpt}
			/>
			<ChangeEmail show={changeMail} hideModal={hideChangeEmail} getProfile={getProfile} />
			{verifyPhoneOpt && (
				<VerifyPhoneOpt
					show={verifyPhoneOpt}
					getProfile={getProfile}
					onBreakVerifyPhoneOtp={showVerifyPhoneOptBreak}
					hideModal={hideVerifyPhoneOpt}
				/>
			)}
			{verifyPhoneOptBreak && <VerifyPhoneOptBreak show={verifyPhoneOptBreak} hideModal={hideVerifyPhoneOptBreak} />}
			<VerifyEmail email={profile.email} show={verifyEmail} hideModal={hideVerifyEmail} getProfile={getProfile} />
		</div>
	);
};

function mapState(state) {
	return {
		session: state.session,
	};
}

export default connect(mapState)(InfoAccount);
